var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 41,
    viewBox: "0 0 54 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3333 0.292297H5C2.23854 0.292297 0 2.52338 0 5.27564V35.1757C0 37.928 2.23854 40.1591 5 40.1591H48.3333C51.0948 40.1591 53.3333 37.928 53.3333 35.1757V5.27564C53.3333 2.52338 51.0948 0.292297 48.3333 0.292297ZM48.3333 5.27564V9.512C45.9977 11.4076 42.2742 14.3553 34.3138 20.5678C32.5596 21.9431 29.0846 25.2471 26.6667 25.2086C24.2492 25.2475 20.773 21.9425 19.0195 20.5678C11.0604 14.3562 7.33593 11.408 5 9.512V5.27564H48.3333ZM5 35.1757V15.9066C7.38687 17.8014 10.7718 20.4603 15.931 24.4869C18.2078 26.2731 22.195 30.2162 26.6667 30.1923C31.1163 30.2162 35.053 26.3303 37.4013 24.4877C42.5605 20.4612 45.9463 17.8016 48.3333 15.9067V35.1757H5Z",
    fill: "#8C8C94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8dcb686cbdad9b8b3ed1310eff9cd044.svg";
export { ForwardRef as ReactComponent };